export default __webpack_public_path__ + "static/media/myinfo-logo.ddd0897c.png";